/**
 * Armazena a função updateSW retornada por registerSW.
 * Usado pelo toast de atualização para chamar skipWaiting + reload.
 */

import type { UpdateSWFn } from './dispatchSwNeedRefresh'

let updateSWFn: UpdateSWFn | null = null

export const setUpdateSW = (fn: UpdateSWFn) => {
  updateSWFn = fn
}

export const getUpdateSW = (): UpdateSWFn | null => updateSWFn
